import React from 'react';

import TransportationCaller from './TransportationCaller';
import Create from '../../helpers/error/Create';
import Error from '../../helpers/error/Error';

async function Delete(path: string) {
  return TransportationCaller.delete(path).catch(error => {
    Create(<Error error={error} />);
  });
}

export default Delete;
